import { render, staticRenderFns } from "./MpDialog.vue?vue&type=template&id=405b91ed&scoped=true"
import script from "./MpDialog.vue?vue&type=script&lang=js"
export * from "./MpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b91ed",
  null
  
)

export default component.exports